module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_subscript.9ce76.png";